<template>
<div>
    <v-sheet class="pa-0 grey lighten-2 d-inline-flex " style="height: 40px; border-radius: 90px;">
        <v-btn color="primary" dark depressed small fab @click="value--" :disabled="value == 0">
            <v-icon>remove</v-icon>
        </v-btn>
        <span class="my-2 mx-3 font-weight-bold">{{value}}</span>
        <v-btn color="primary" dark depressed small fab @click="value++" :disabled="value == count">
            <v-icon>add</v-icon>
        </v-btn>
    </v-sheet>

</div>
</template>

<script>
export default {

    components: {},

    props: {
        count: [Number, String]
    },

    data: () => ({
        modal: false,
        value: 0,
        room: null
    }),
    watch: {
        value() {
            this.$emit('bookRoom', this.value)
        }
    },

    methods: {}

}
</script>
